import { CONST } from "../sideTypes"
import { MenuItemCategory, MenuItemType } from "../../Components/navigationTypes"
import { ClientPortalModalType } from "../../Components/clientportal/types"


export const clientPortalList: () => Array<MenuItemType> =
    () => {
        return [
            ClientPortal,
            ClientTasks,
            RemoteClosing,
        ];
    }

const ClientPortal: MenuItemType =
{
    label: "ClientConnect",
    navigate: {
        component: "main",
        url: "lfmaster.asp",
    },
    subItems: [
        {
            label: "Client Intake Information",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalState: 'ClientIntake'
                },
                controller: {
                    tabName: "ClientConnect",
                    tabNumber: 0,
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
        },
        {
            label: "Document Exchange",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalState: 'DocumentExchange'
                },
                controller: {
                    tabName: "ClientConnect",
                    tabNumber: 1,
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
        },
    ],
    addOptions: [],
    type: MenuItemCategory.Heading
}

const ClientTasks: MenuItemType =
{
    label: "Client Tasks",
    navigate: {
        component: "main",
        url: "lfmaster.asp",
    },
    subItems: [
        {
            label: "Client Retainer",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalModalType: ClientPortalModalType.CLIENT_RETAINER
                },
                controller: {
                    tabName: "ClientTasks",
                    tabNumber: 0,
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
        },
        {
            label: "Information Sharing Consent",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalModalType: ClientPortalModalType.INFORMATION_SHARING_CONSENT
                },
                controller: {
                    tabName: "ClientTasks",
                    tabNumber: 1,
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
        },
        {
            label: "Identity Verification",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalModalType: ClientPortalModalType.ID_VERIFICATION
                },
                controller: {
                    tabName: "ClientTasks",
                    tabNumber: 2,
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
            appCode: ['RPW', 'RPWBC', 'RPWMB', 'RPWNS', 'RPWSK', 'RPWAB']
        },
        {
            label: "Source of Funds",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalModalType: ClientPortalModalType.SOURCE_OF_FUNDS
                },
                controller: {
                    tabName: "ClientTasks",
                    tabNumber: 4,
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Contract
        },
    ],
    addOptions: [],
    type: MenuItemCategory.Heading
}

const RemoteClosing: MenuItemType =
{
    label: "E-Signing",
    navigate: {
        component: "main",
        url: "lfmaster.asp",
    },
    subItems: [
        {
            label: "Manage Session",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalState: 'esigning'
                },
                controller: {
                    tabName: "E-Signing",
                    tabNumber: 0,
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
        },
    ],
    addOptions: [],
    type: MenuItemCategory.Heading
}